import React from "react";

const Protection = (props) => {
  return (
    <svg
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.64258 13.8277C8.4806 13.8277 8.32421 13.7656 8.20134 13.647L5.42541 10.8801C5.17966 10.6317 5.17407 10.2307 5.41983 9.98229C5.66559 9.73383 6.06214 9.72819 6.3079 9.97664L8.64258 12.3087L13.6973 7.34529C13.9487 7.10248 14.3452 7.10813 14.5854 7.35658C14.8256 7.61068 14.82 8.0116 14.5742 8.2544L9.07824 13.6526C8.95536 13.7712 8.79897 13.8333 8.64258 13.8333V13.8277Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.2"
      />
      <path
        d="M10 20.5C9.95023 20.5 9.90045 20.4942 9.85621 20.4826C3.91627 18.9901 0.769322 14.1295 0.498319 6.03426C0.476196 5.31417 0.476196 4.66957 0.476196 4.14692C0.476196 3.78107 0.75273 3.49071 1.10116 3.49071C4.27576 3.49071 7.06875 2.54994 9.64051 0.621951C9.85621 0.45935 10.1493 0.45935 10.365 0.621951C12.9368 2.55575 15.7353 3.49071 18.9044 3.49071C19.2473 3.49071 19.5238 3.78107 19.5238 4.14112C19.5238 4.66957 19.5238 5.30836 19.5017 6.03426C19.2307 14.1237 16.0837 18.9843 10.1493 20.4826C10.0996 20.4942 10.0553 20.5 10.0055 20.5H10ZM1.7206 4.78571C1.7206 5.15157 1.72613 5.55807 1.74272 5.9878C1.9916 13.4559 4.69056 17.7706 10 19.1702C15.3039 17.7706 18.0084 13.4559 18.2573 5.9878C18.2739 5.55227 18.2794 5.15157 18.2794 4.78571C15.2375 4.67538 12.522 3.74042 10 1.94599C7.47802 3.74042 4.76246 4.67538 1.7206 4.78571Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.3"
      />
    </svg>
  );
};

export default Protection;
